import React from "react";
import "./Bio.css";
const Bio = () => {
  return (
    <div className="my_bio">
      <div className="bio_line">Bio</div>
      <ul>
        <li>2002 Born in Thiruvarur, Tamil Nadu, India</li>
        <li>2016-2017 SSLC-Government Higher Secondary School.</li>
        <li>2018-2019 HSC-National Higher Secondary School.</li>
        <li>2019-2023 B.Tech-IT Paavai Engineering College.</li>
      </ul>
    </div>
  );
};

export default Bio;
